import { createSlice } from "@reduxjs/toolkit";
import {
  getAllAboutStats,
  getAboutStatsById,
  createAboutStats,
  updateAboutStats,
  deleteAboutStats,
} from "actions/aboutStats";

const initialState = {
  loading: false,
  aboutStats: [],
  aboutStat: null,
  createLoading: false,
  updateLoading: false,
  deleteLoading: false,
  error: null,
};

export const aboutStatsSlice = createSlice({
  name: "aboutStats",
  initialState,
  reducers: {
    clearAboutStat: (state) => {
      state.aboutStat = null;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(getAllAboutStats.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllAboutStats.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.aboutStats = payload || [];
      })
      .addCase(getAllAboutStats.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload;
      });

    builder
      .addCase(getAboutStatsById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAboutStatsById.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.aboutStat = payload;
      })
      .addCase(getAboutStatsById.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload;
      });

    builder
      .addCase(createAboutStats.pending, (state) => {
        state.createLoading = true;
        state.error = null;
      })
      .addCase(createAboutStats.fulfilled, (state, { payload }) => {
        state.createLoading = false;
        state.aboutStat = payload;
      })
      .addCase(createAboutStats.rejected, (state, { payload }) => {
        state.createLoading = false;
        state.error = payload;
      });

    builder
      .addCase(updateAboutStats.pending, (state) => {
        state.updateLoading = true;
        state.error = null;
      })
      .addCase(updateAboutStats.fulfilled, (state, { payload }) => {
        state.updateLoading = false;
        state.aboutStat = payload;
      })
      .addCase(updateAboutStats.rejected, (state, { payload }) => {
        state.updateLoading = false;
        state.error = payload;
      });

    builder
      .addCase(deleteAboutStats.pending, (state) => {
        state.deleteLoading = true;
        state.error = null;
      })
      .addCase(deleteAboutStats.fulfilled, (state) => {
        state.deleteLoading = false;
      })
      .addCase(deleteAboutStats.rejected, (state, { payload }) => {
        state.deleteLoading = false;
        state.error = payload;
      });
  },
});

export const { clearAboutStat, clearError } = aboutStatsSlice.actions;

export default aboutStatsSlice.reducer;
